import {FC, PropsWithChildren} from "react";
import {SnackbarProvider} from "notistack"
import {StyledErrorSnackbar, StyledInfoSnackbar, StyledSuccessSnackbar} from "./StyledSnackbars"
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ProcessInProgressSnackbar from "./components/ProcessInProgressSnackbar";
import {useTheme} from "@mui/material";

const SnackbarProviderWrapper : FC<PropsWithChildren> = ({
	children
}) => {
	const theme = useTheme();

	return(
		<SnackbarProvider
			Components={{
				success: StyledSuccessSnackbar,
				error: StyledErrorSnackbar,
				info: StyledInfoSnackbar,
				proccesInProgress: ProcessInProgressSnackbar
			}}
			iconVariant={{
				success: <CheckCircleOutlineOutlinedIcon sx={{color: theme.palette.success.light, paddingRight: "8px"}} />,
				error: <InfoOutlinedIcon sx={{color: theme.palette.common.white, paddingRight: "8px"}} />
			}}
			classes={{
				containerAnchorOriginTopRight: "notistack-right-top-position"
			}}
		>
			{children}
		</SnackbarProvider>
	)
}

declare module "notistack" {
	interface VariantOverrides {
		proccesInProgress: true;
	}
}

export default SnackbarProviderWrapper